import { createFileRoute } from '@tanstack/react-router';

import {
  buildGuards,
  hasFlagEnabled,
  hasPermission,
} from '@mint-lib/routing-guards';
import { z } from 'zod';

const aiHubGuard = buildGuards(
  hasFlagEnabled('aiHubAccess'),
  hasPermission('aiHubFeature:view'),
);

export const Route = createFileRoute('/_secured/ai-hub/$chatId/')({
  validateSearch: z.object({
    voiceMode: z.boolean().optional(),
  }),
  loader: async ({ context }) => {
    await context.getInstance('i18n', '@mint-lib/formatting-hooks');
  },
  head: ({ params }) => ({
    meta: [
      {
        title: `AI Hub – Chat ${params.chatId} | MINT`,
      },
    ],
  }),
  async beforeLoad({ context }) {
    if (await context.isFlagEnabled('@mint/arm', 'command')) {
      const guardsContext = await context.getGuardContext(
        await context.getInstance('flagsmith', '@myn/secured'),
      );

      if (!aiHubGuard(guardsContext)) {
        throw new Response('Forbidden', { status: 403 });
      }

      return;
    }

    // TODO(STZF-16): remove once the `command` flag is fully rolled out
    const hasAccess = await context.isFlagEnabled(
      '@myn/secured',
      'aiHubAccess',
    );

    const hasViewPermission = await context.hasPermission('aiHubFeature:view');

    if (!(hasAccess && hasViewPermission)) {
      throw new Response('Forbidden', { status: 403 });
    }
  },
});
